import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  loaderContainer: {
    borderRadius: 4,
    backgroundColor: theme.palette.colors.lightGray,
    overflow: 'hidden',
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
  },
  root: {
    borderRadius: 4,
    overflow: 'hidden',
  },
  loader: {
    color: theme.palette.colors.white,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/components/Message/components/VideoMessage/useStyles.js